export default __webpack_public_path__ + "static/media/4_projetos.32b47ff6.svg";